// src/pages/Utility/StikerPrint.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';


const StikerPrint = () => {

  const navigate = useNavigate();
  
  const [line1, setLine1] = useState('-');
   
  const handleBack = () => {
    navigate('../dashboard');
  };

    useEffect(() => {
      document.title = "Sticker Print";
    }, []); // for Title Set

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
            handleBack();
          }        
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, []);
   

    const printLabel50x25 = () => {
      const width = 400;
      const height = 300;

      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      const printWindow = window.open(
        "",
        "",
        `width=${width},height=${height},left=${left},top=${top}`
      );

      printWindow.document.write(`
          <html>
            <head>
              <title>Print Label</title>
              <style>
                @page {
                  size: 50mm 25mm;
                  margin: 0;
                }

                html, body {
                  width: 50mm;
                  height: 25mm;
                  margin: 0;
                  padding: 0;
                }

                body {
                  font-family: Arial, sans-serif;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  overflow: hidden;
                }

                .label {
                  width: 50mm;
                  height: 25mm;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  text-align: center;
                  box-sizing: border-box;
                  padding: 0;
                }

                .cust-name {
                  font-weight: bold;
                  font-size: 18px;
                  line-height: 1.4;
                  word-break: break-word;
                }
              </style>
            </head>

            <body>
              <div class="label">
                <div class="cust-name">${line1}</div>
              </div>
            </body>
          </html>
      `);

      printWindow.document.close();
      printWindow.focus();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 300);
    };

   
    
  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div></div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Stiker Print</b>
              <div> </div>
          </div>

          <div
            style={{
              width: "100%",
              background: "#e6e6e6",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ width: "400px" }}>

              {/* INPUT */}
              <input
                type="text"
                placeholder="Enter text here"
                maxLength={50}
                onChange={(e) => setLine1(e.target.value)} 
                style={{
                  width: "100%",
                  border: "none",
                  borderRadius: "8px",
                  textAlign: "center",
                  fontSize: "20px",
                  marginTop: "50px",
                  marginBottom: "10px",
                  outline: "none",
                }}
              />

              {/* BUTTONS */}
              <div style={{ display: "flex", gap: "20px" }}>
                <Button color="success" style={{ marginLeft: '10px', marginRight: '10px' }} onClick={printLabel50x25}>
                  Print
                </Button>

                <Button color="primary" style={{ marginLeft: '10px', marginRight: '10px' }} onClick={handleBack}>
                  Close
                </Button>
                
              </div>

            </div>
          </div>
    </div>
  );
};

export default StikerPrint;
